import { render, staticRenderFns } from "./DebrisGathererFleet.vue?vue&type=template&id=b8513730&scoped=true&"
import script from "./DebrisGathererFleet.vue?vue&type=script&lang=js&"
export * from "./DebrisGathererFleet.vue?vue&type=script&lang=js&"
import style0 from "./DebrisGathererFleet.vue?vue&type=style&index=0&id=b8513730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8513730",
  null
  
)

export default component.exports